import { module } from 'modujs';
import { lerp } from '../utils/maths';
import { gsap } from 'gsap';

const MAX_ROTATION = 50;

export default class extends module {
    constructor(m) {
        super(m);

        this.$cursor = this.$('cursor')[0];
        this.$cursorImage = this.$('cursorImage')[0];
        this.$zone = this.$('zone')[0];
        this.hasOffset = (typeof this.getData('offset') == 'string');
        // this.$items = this.$('item');

        this.events = {
            mouseenter: {
                zone: 'mouseenter',
                item: 'itemEnter'
            },
            mouseleave: {
                zone: 'mouseleave',
                item: 'itemLeave'
            }
        }

        this.bcr = this.$zone.getBoundingClientRect();

        this.mouse = {
            x: this.bcr.width/2,
            y: this.bcr.height/2
        }
        this.mouseLerp = {
            x: this.bcr.width/2,
            y: this.bcr.height/2
        }

        this.lerpDelay = {
            value: 0.7
        }

        this.windowWidth = window.innerWidth;
    }

    init() {
        this.bindMousemove = this.mousemove.bind(this);
        window.addEventListener('mousemove',this.bindMousemove);

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize',this.bindResize);
    }

    itemEnter(e) {
        
        let img = document.createElement('img');
        img.src = e.currentTarget.getAttribute('data-image');
        img.dataset.id = e.currentTarget.getAttribute('data-id');
        
        this.$cursorImage.appendChild(img);
        gsap.delayedCall(0.1,() => {
            img.classList.add('is-active');
        });

    }

    itemLeave(e) {
        let images = this.$cursorImage.querySelectorAll('img');

        if(this.delayedCall!= undefined) {
            this.delayedCall.kill();
        }

        if(images != undefined) {
            this.delayedCall = gsap.delayedCall(0.6,() => {
                images.forEach((img, index) => {
                    if(index < images.length - 1) {
                        this.$cursorImage.removeChild(img);
                    }
                })
            });
        }
    }

    trigger(e) {
        if(e.mode == 'enter') {
            this.animate();
        } else {
            cancelAnimationFrame(this.raf);
        }
    }

    mouseenter(e) {

        this.el.classList.add('is-active');

        gsap.to(this.lerpDelay,{
            value: 0.1
        });

    }

    mousemove(e) {

        this.bcr = this.$zone.getBoundingClientRect();

        this.mouse.x = e.clientX - this.bcr.left;
        this.mouse.y = e.clientY - this.bcr.top;

        if(this.hasOffset) {
            this.progress = (this.mouse.x / this.windowWidth) - 0.5

            let offset = (this.progress) * this.windowWidth * 0.2;
            this.mouse.x -= offset;
        }
    }

    mouseleave(e) {
        this.el.classList.remove('is-active');

        gsap.to(this.lerpDelay,{
            value: 0.7
        });

        if(this.delayedCall!= undefined) {
            this.delayedCall.kill();
        }

        let images = this.$cursorImage.querySelectorAll('img');
        if(images != undefined) {
            this.delayedCall = gsap.delayedCall(0.6,() => {
                images.forEach((img, index) => {
                    this.$cursorImage.removeChild(img);
                })
            });
        }
        
    }

    animate() {
        this.raf = requestAnimationFrame(() => this.animate());

        this.mouseLerp.x = lerp(this.mouseLerp.x, this.mouse.x, this.lerpDelay.value);
        this.mouseLerp.y = lerp(this.mouseLerp.y, this.mouse.y, this.lerpDelay.value);
        
        let relativeRotation = -(this.mouseLerp.x - this.mouse.x) / this.windowWidth;
        
        
        if(this.hasOffset) {

            this.$cursor.style.transform = `translate3d(${this.mouseLerp.x}px,${this.mouseLerp.y}px,0) rotate(${this.progress * MAX_ROTATION}deg) scale3d(${1-Math.abs(relativeRotation)},${1-Math.abs(relativeRotation)},1)`;

        } else {
            this.$cursor.style.transform = `translate3d(${this.mouseLerp.x}px,${this.mouseLerp.y}px,0) rotate(${relativeRotation * MAX_ROTATION}deg) scale3d(${1-Math.abs(relativeRotation)},${1-Math.abs(relativeRotation)},1)`;
        }
    }

    resize() {
        if(this.windowWidth != window.innerWidth || !window.isMobile) {
            this.windowWidth = window.innerWidth;
            this.bcr = this.$zone.getBoundingClientRect();
        }

    }

    destroy() {
        cancelAnimationFrame(this.raf);
        window.removeEventListener('mousemove',this.bindMousemove);
    }
}
